import React from 'react';
import { Hand, Crosshair, PenTool } from 'lucide-react';

export const ModeControls = ({ mode, onModeChange, surveyActive, showRoutePlanner, onToggleRoutePlanner }) => {
  const getButtonStyles = (active) => {
    if (active) return 'bg-blue-500 text-white';
    return 'bg-gray-700 text-gray-400 hover:bg-gray-600 hover:text-white';
  };

  return (
    <div className="flex flex-col space-y-1">
      <button
        onClick={() => onModeChange('pan')}
        className={`p-2 rounded-lg flex items-center gap-2 w-full ${getButtonStyles(mode === 'pan')}`}
        title="Pan Mode"
      >
        <Hand className="w-4 h-4" />
        <span className="text-sm">Pan</span>
      </button>
      <button
        onClick={() => onModeChange('selection')}
        className={`p-2 rounded-lg flex items-center gap-2 w-full ${getButtonStyles(mode === 'selection')}`}
        title="Selection Mode"
        disabled={!surveyActive}
      >
        <Crosshair className="w-4 h-4" />
        <span className="text-sm">Select</span>
      </button>
      <button
        onClick={() => onModeChange('drawing')}
        className={`p-2 rounded-lg flex items-center gap-2 w-full ${getButtonStyles(mode === 'drawing')}`}
        title="Drawing Mode"
        disabled={!surveyActive}
      >
        <PenTool className="w-4 h-4" />
        <span className="text-sm">Draw</span>
      </button>
    </div>
  );
};